import React, { useState } from "react";
import userService from "../../services/user.service";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";

const ChangePassword = (props: { userId: number; username: string }) => {
  const { userId, username } = props;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const ChangePWSchema = Yup.object().shape({
    password: Yup.string().required("กรอกรหัสด้วยครับ"),
    password_confirm: Yup.string().oneOf(
      [Yup.ref("password"), null],
      "รหัสไม่ตรงกันครับ"
    ),
  });
  const onSubmit = (values: any) => {
    userService
      .changePW(values)
      .then(() => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "บันทึกสำเร็จ",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          handleClose();
          window.location.reload();
        });
      })
      .catch(() => {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "มีความผิดพลาดบางอย่าง",
          showConfirmButton: false,
          timer: 1500,
        });
      });
  };
  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-info ms-1 text-white"
        onClick={handleShow}
      >
        เปลี่ยนรหัสผ่าน
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            เปลี่ยนรหัสผ่านใหม่ ของ Username: {username}
          </Modal.Title>
        </Modal.Header>
        <Formik
          validationSchema={ChangePWSchema} //กำหนด validation Schema
          initialValues={{
            //กำหนด initialValues
            id: userId,
            password: "",
            password_confirm: "",
          }}
          onSubmit={onSubmit}
        >
          {({ errors, touched }) => (
            <Form>
              <Modal.Body>
                <div className="row g-3">
                  <div className="col-6">
                    <label htmlFor="password" className="form-label">
                      รหัสผ่านใหม่
                    </label>
                    <Field
                      type="password"
                      className={`form-control ${
                        touched.password
                          ? errors.password
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      name="password"
                    />
                    <ErrorMessage
                      name="password"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                  <div className="col-6">
                    <label htmlFor="password_confirm" className="form-label">
                      Password
                    </label>
                    <Field
                      type="password"
                      className={`form-control ${
                        touched.password_confirm
                          ? errors.password_confirm
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      name="password_confirm"
                    />
                    <ErrorMessage
                      name="password_confirm"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button type="submit" className="btn btn-primary">
                  บันทึกข้อมูล
                </button>
                <button type="reset" className="btn btn-warning">
                  ล้าง
                </button>

                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleClose}
                >
                  Close
                </button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
        {/*  */}
      </Modal>
    </>
  );
};

export default ChangePassword;
